import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import schema from './chartForm.schema';

import {
  saveChart,
  hideChartModalForAddEdit,
} from './store/actions';

import {
  isSavingChartInProgressSelector,
} from './store/selectors';

import { ChartPropTypes } from './propTypes';
import PropTypes from 'prop-types';


const ModalTitles = {
  ADD: 'Add Chart',
  EDIT: 'Edit Chart',
};

class AddChartModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    chartName: PropTypes.shape({
      value: PropTypes.string.isRequired,
    }),
    isSavingInProgress: PropTypes.bool.isRequired,
    entityToEdit: ChartPropTypes,
    openForEdit: PropTypes.bool,
    canModify: PropTypes.bool,
    isVisible: PropTypes.bool.isRequired,
  };

  state = {
    addAnother: false,
  };

  save = (chartData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit, entityToEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity({
        chartData,
        entityToEdit,
        period,
      }, openForEdit, { callback: resetForm, keepOpenAfterSaving: addAnother });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      hideModal,
      isSavingInProgress,
      isVisible,
    } = this.props;


    const submit = () => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    };

    const submitAndAddAnotherAction = () => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    };

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-chart-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={submit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and add another"
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  isSavingInProgress: isSavingChartInProgressSelector(state),
});

export default connect(
  mapStateToProps,
  {
    saveEntity: saveChart,
    hideModal: hideChartModalForAddEdit,
  }
)(AddChartModal);


